import createPersistedState from "vuex-persistedstate";
import { createStore } from "vuex";
import basic from "./module/basic.module";
import cart from "./module/cart.module";
import userData from "./module/userData.module";
import auth from "./module/auth.module";
import order from "./module/order.module";
import product from "./module/product.module";
import coupon from "./module/coupon.module";
import line from "./module/line.module";
import spreadsheet from "./module/spreadsheet.module";
import payment from "./module/payment.module";
import point from "./module/point.module";
import storeMenu from "./module/storeMenu.module";
import storeList from "./module/storeList.module";
import deposit from "./module/deposit.module";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    basic,
    cart,
    userData,
    auth,
    order,
    product,
    coupon,
    line,
    spreadsheet,
    payment,
    point,
    storeMenu,
    storeList,
    deposit
  },
  plugins: [createPersistedState({
    // 不加入 deposit：保管/領取狀態每次進頁重抓，避免顯示過期數量
    paths: ['auth', 'line', 'basic', 'cart', 'userData', 'payment', 'point', 'order', 'coupon'],
    storage: {
      getItem: (key) => localStorage.getItem(key),
      setItem: (key, value) => {
        try {
          localStorage.setItem(key, value)
        } catch (e) {
          console.warn('localStorage 寫入失敗', e)
        }
      },
      removeItem: (key) => localStorage.removeItem(key)
    }
  })]
});
